import { useContext } from "react";
import { GlobalContext, GlobalContextType } from "./GlobalContextProvider";

export function useChannelContext() {
  const { channels } = useContext<GlobalContextType>(GlobalContext);
  return channels;
}
